import(/* webpackMode: "eager" */ "/var/www/vhosts/lenkijosbaldai24.lt/mini6.ekotora.lt/src/app/error.tsx");
